module.exports = __webpack_public_path__ + "static/media/filled_bar_SMAP_tall.a34c5838.svg";